<template>
  <TemplateView>
    <div class="container">
      <div class="d-flex flex-wrap mb-8">
        <template v-for="(page, p) in list">
          <BaseButton
            v-if="page.if"
            :text="page.text"
            style-type="chip"
            :key="'settingCompany' + p"
            :disabled="$route.name === page.toName || $route.name === page.toName + 'Edit'"
            @click="$router.push({ name: page.toName })"
          />
        </template>
      </div>
      <router-view />
    </div>
  </TemplateView>
</template>

<script>
export default {
  name: 'settingCompany',
  computed: {
    list() {
      return [
        {
          toName: 'SettingCompanyGeneral',
          text: this.localStorage.translations.pages['setting-setting_company'].all['main'],
          if: this.$userCheckAccess({
            abilities: 'edit_general_settings',
          }),
        },
        {
          toName: 'SettingCompanyGeoPosition',
          text: this.localStorage.translations.pages['setting-setting_company'].all['geoposition'],
          if: this.$userCheckAccess({
            abilities: 'edit_geo_position_settings',
          }),
        },
        {
          toName: 'SettingCompanyStartStop',
          text: this.localStorage.translations.pages['setting-setting_company'].all['start_stop'],
          if: this.$userCheckAccess({
            abilities: 'edit_start_stop_settings',
          }),
        },
        {
          toName: 'SettingCompanyCalendar',
          text: this.localStorage.translations.pages['setting-setting_company'].all[
            'mobile_calendar'
          ],
          if: this.$userCheckAccess({
            abilities: 'edit_mobile_calendar_settings',
          }),
        },
        {
          toName: 'SettingCompanyFinancialSystem',
          text: this.localStorage.translations.pages['setting-setting_company'].all['fin-system'],
          if: this.$userCheckAccess({
            abilities: 'edit_financial_settings',
          }),
        },
        {
          toName: 'SettingCompanySalarySettings',
          text:
            this.localStorage?.translations?.pages?.['setting-setting_company']?.all?.[
              'salary_settings'
            ] || 'Salary settings',
          if: true,
        },
        /*{
          toName: 'SettingCompanyProject',
          text: this.localStorage.translations.pages['setting-setting_company'].all['project_settings'],
          if: true,
        },*/
      ]
    },
  },
  mounted() {
    const findReadyPage = this.list.find((i) => i.if)
    this.$router.replace({ name: findReadyPage ? findReadyPage.toName : 'Home' })
  },
}
</script>

<style scoped lang="scss">
.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}
</style>
